import { gql } from '@apollo/client'

export const CREATE_INCOMPLETE_USER_SURVEYS = gql`
  mutation CreateIncompleteUserSurveys($userIds: [Int!]!) {
    createIncompleteUserSurveys(userIds: $userIds) {
      userIds
    }
  }
`
